import { GetterTree } from 'vuex';
import { IContractManagementState } from '@/contract-management/store/contract-management.store';
import { RootState } from '@/store/store';
import { IDocument } from '@/types/Document';

export const getters: GetterTree<IContractManagementState, RootState> = {
  selectedDocuments: (state: IContractManagementState): IDocument[] => {
    return state.documents.filter((document: IDocument) =>
      state.selectedDocumentIds.includes(document.id)
    );
  },
  showFooterBar: (state: IContractManagementState): boolean => {
    return state.selectedDocumentIds.length > 0;
  },
};
